import { inject, Injectable } from '@angular/core';
import { AppConfiguratorService } from '../layout/components/app.configurator.service';

type SafeNotificationPermission = NotificationPermission | 'unsupported';

@Injectable({
  providedIn: 'root',
})
export class NotificationPermissionMonitor {
  private notificationService = inject(AppConfiguratorService);
  private checkInterval: ReturnType<typeof setInterval> | null = null;
  private lastPermission: SafeNotificationPermission =
    this.getNotificationPermission();

  startMonitoring(): void {
    if (!this.isNotificationSupported()) {
      return;
    }

    this.checkPermissionChange();

    this.checkInterval = setInterval(() => {
      this.checkPermissionChange();
    }, 3000);
  }

  stopMonitoring(): void {
    if (this.checkInterval) {
      clearInterval(this.checkInterval);
      this.checkInterval = null;
    }
  }

  private isNotificationSupported(): boolean {
    return typeof window !== 'undefined' && 'Notification' in window;
  }

  private getNotificationPermission(): SafeNotificationPermission {
    if (!this.isNotificationSupported()) {
      return 'unsupported';
    }

    return window.Notification.permission;
  }

  private async checkPermissionChange(): Promise<void> {
    const currentPermission = this.getNotificationPermission();

    if (currentPermission === 'unsupported') {
      return;
    }

    if (currentPermission !== this.lastPermission) {
      console.log('🔔 Mudança de permissão detectada:', {
        anterior: this.lastPermission,
        atual: currentPermission,
      });

      this.lastPermission = currentPermission;

      if (currentPermission === 'denied' || currentPermission === 'default') {
        await this.handlePermissionRevoked();
      }
    }
  }

  private async handlePermissionRevoked(): Promise<void> {
    console.warn('⚠️ Permissão de notificação revogada pelo usuário');

    await this.notificationService.checkNotificationStatus();
  }
}
